import { useField, useFormikContext } from 'formik';

import {
    AssignedSupplierSelect,
    AssignedSupplierSelectProps,
} from '../common/form-elements/CompanySelect/AssignedSupplierSelect';

interface FormikVesselDefaultSupplierSelectProps
    extends Omit<AssignedSupplierSelectProps, 'onChange' | 'value' | 'options'> {
    name: string;
    onChange?: (supplierId: string) => void;
}

export const FormikVesselDefaultSupplierSelect = (props: FormikVesselDefaultSupplierSelectProps) => {
    const { onChange, ...selectProps } = props;
    const [field, meta, helpers] = useField<string>(props.name);
    const { validateOnChange } = useFormikContext();

    return (
        <AssignedSupplierSelect
            {...selectProps}
            value={field.value}
            onChange={(supplierId) => {
                const hasChanged = field.value !== supplierId;

                helpers.setValue(supplierId);
                if (!validateOnChange && meta.error) {
                    helpers.setError(undefined);
                }
                if (hasChanged) {
                    onChange?.(supplierId);
                }
            }}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
};
